import { render } from "./SettingsPage.vue?vue&type=template&id=4699562b&scoped=true&ts=true"
import script from "./SettingsPage.vue?vue&type=script&lang=ts"
export * from "./SettingsPage.vue?vue&type=script&lang=ts"

import "./SettingsPage.vue?vue&type=style&index=0&id=4699562b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4699562b"]])

export default __exports__